module.exports = __webpack_public_path__ + "static/media/hero2.266bdbbc.jpg";